// extracted by mini-css-extract-plugin
export var container = "styles-module--container--6eB7G";
export var fadeIn = "styles-module--fadeIn--QK6VE";
export var fadeInAndMoveUp = "styles-module--fadeInAndMoveUp--ARXJj";
export var large = "styles-module--large--gFLRc";
export var scaleUp = "styles-module--scaleUp--uvEtG";
export var slideIn = "styles-module--slideIn--9Hut3";
export var small = "styles-module--small--svcGt";